// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aeUa","col":"styles_col__1MlDS"};